import React, { useContext, useEffect, useState } from "react";
import { Grid, IconButton, TextField, Autocomplete, Button, Box } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import { GetContenedores } from "../../../../hooks/getContainers";
import moment from "moment";
import barcode from '../../../resources/imgs/barcode.png'
import { ThemeContext } from "@emotion/react";
import { RevisionesParte } from "./revisiones";

const GeneralesProducto = ({revisiones, setRevisiones, setContenedor, setOpen, dataPart, open}) => {

    const theme = useContext(ThemeContext)

    const [options, setOptions] = useState([])
    const {getContenedoresMutation} = GetContenedores();
    const [notas, setNotas] = useState(dataPart?.part_observaciones)
    const [barcodeNum, setBarcodeNum] = useState(dataPart?.part_barcode)
    const [inputValue, setInputValue] = useState([]);

    const get_contenedores = () => {
        getContenedoresMutation({},{
            onSuccess: (data) => {
                const opt = data.map(con => {
                    return {
                        label: con.cont_nombre,
                        id: con.cont_id
                    }
                })
                setOptions([{label: '', id: 0}, ...opt])
                if(dataPart?.partes_contenedores.length > 0){
                    const unidadesFiltradas = data.filter((unidad) => {
                        return dataPart?.partes_contenedores.some((parteUnidad) => {
                            return parteUnidad.cont_id === unidad.cont_id;
                        });
                    });
                    const dataAutoC = unidadesFiltradas.map(un =>{return {label: un?.cont_nombre, id: un?.cont_id}})
                    setInputValue([...inputValue, ...dataAutoC])
                    setContenedor([unidadesFiltradas[0].cont_id])
                }
            }, 
            onError: (error) => {
                console.log(error)
            }
        })
    }

    useEffect(() => {
        get_contenedores();
    }, [open]);

    const handleChange = (event, newValue) => {
        setInputValue(newValue);
        setContenedor(newValue.map(val => {return val?.id}))
    };

    return(
        <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8} sx={{p:0, mb:1, pr:1}} >
                <TextField
                    id="notes"
                    label="Notas"
                    fullWidth
                    size="small"
                    multiline
                    rows={2}
                    value={notas}
                    onChange={(e)=> {  
                        setNotas(e.target.value) 
                    }}
                    sx={{color: theme.palette.primary.input}}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={{p:0, mb:1, flexDirection:'column', display:'flex', alignItems:'center'}}>
                <TextField
                    id="barcode"
                    label="Codigo barras"
                    fullWidth
                    size="small"
                    value={barcodeNum}
                    onChange={(e)=> {  
                        setBarcodeNum(e.target.value) 
                    }}
                    sx={{color: theme.palette.primary.input}}
                />
                <img src={barcode} alt="img_barcode" loading="lazy" style={{width:180, height:50, ml:1}}/>
            </Grid>
            <Grid item xs={12}  sx={{p:0}} >
                <Autocomplete
                multiple
                fullWidth
                id="contenedores_auto"
                getOptionLabel={(opcion) => opcion.label}
                value={inputValue}
                filterSelectedOptions
                onChange={handleChange}
                options={options}
                renderOption={(props, option)=> (
                    <Box sx={{p:1}}>
                        {option.id === 0 ? (
                            <Button variant="contained" 
                                    className="btn_system" 
                                    sx={{height:25}}
                                    onClick={() => setOpen(true)}
                                    >
                                + Nuevo contenedor
                            </Button>
                        ): (
                            <Box {...props}>{option.label}</Box>
                        )}
                    </Box>
                )}
                renderInput={(params) => 
                    <TextField {...params} label="Contenedor" size="small" />
                }
                />
            </Grid>
            <RevisionesParte  key='revisiones_parte' part_id={dataPart?.part_id} part_nombre={dataPart?.part_nombre}/>
        </Grid>
    )
}

export default GeneralesProducto;